var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3688,
    cy: 28,
    r: 26.5,
    fill: "#1D1D1D",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9781 22.1189L13.9781 22.1189L13.9773 22.1253C13.5403 25.9597 13.5589 30.3836 14.169 34.2149C14.5412 36.5522 16.552 38.3127 18.9946 38.5132L21.327 38.7047C26.2174 39.1061 31.1356 39.1061 36.026 38.7047L38.3584 38.5132C40.801 38.3127 42.8118 36.5522 43.184 34.2149C43.7941 30.3835 43.8127 25.9599 43.3757 22.1256L43.3757 22.1256L43.3749 22.1191C43.3183 21.6739 43.2547 21.2292 43.184 20.7853C42.8118 18.4479 40.801 16.6874 38.3584 16.4869L36.026 16.2955C31.1356 15.894 26.2174 15.894 21.327 16.2955L18.9946 16.4869C16.552 16.6874 14.5412 18.4479 14.169 20.7853C14.0983 21.2291 14.0347 21.6737 13.9781 22.1189ZM21.6094 19.4714C26.3119 19.0854 31.0411 19.0854 35.7436 19.4714L38.076 19.6628C39.0243 19.7407 39.7621 20.4134 39.9032 21.2529L31.6317 25.5922C29.7948 26.5559 27.5581 26.5559 25.7212 25.5922L17.4498 21.2529C17.5908 20.4134 18.3287 19.7407 19.2771 19.6628L21.6094 19.4714ZM33.2213 28.39L40.2983 24.6773C40.5142 27.6967 40.3833 30.7328 39.9057 33.7323C39.7709 34.5787 39.03 35.259 38.076 35.3373L35.7436 35.5287C31.0411 35.9147 26.3119 35.9147 21.6094 35.5287L19.2771 35.3373C18.3231 35.259 17.5821 34.5787 17.4473 33.7323C16.9697 30.7329 16.8388 27.6968 17.0547 24.6773L24.1316 28.39C26.9591 29.8733 30.3938 29.8733 33.2213 28.39Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.c774e710dd97f84f85d5025479e50b4e.svg";
export { ForwardRef as ReactComponent };